import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import * as store from '../../reducers/store';

import { onFormComplete } from '../../utils/form';

export const useFormSetsEndRedirect = (
  authenticationCode: string,
  skipRecommendation?: boolean,
) => {
  const history = useHistory();
  const multiFormSet = useSelector((store: store.All) => store.multiFormSet);
  const masterPracticePreference = useSelector(
    (store: store.All) => store.masterPracticePreference,
  );
  const formSets = useSelector((store: store.All) => store.formSets);
  return {
    formSets,
    onFormSetEnd: () =>
      onFormComplete({
        history,
        authenticationCode,
        multiFormSet,
        collectFeedback: masterPracticePreference.collectFeedback,
        formSets,
        skipRecommendation,
      }),
  };
};
